<template>
  <div id="page-wrapper" :class="popupShown ? 'popup-shown' : ''">

    <transition name="teampopupdash">
      <div id="popup-wrapper" v-if="popupShown">
        <template>
          <button class="btn btn-link text-white close" @click.prevent.stop="closePopup">
            <i class="fal fa-times"></i>
          </button>
          <h2>
            {{user.fullname}}
            <span class="pl-3 small text-muted">{{formatDate(popupSubmission.finalized ? popupSubmission.finalized : popupSubmission.submitted)}}
          </span>
          </h2>

          <user-review @close="closePopup" :user="user" :submission="popupSubmission"></user-review>
        </template>
      </div>
    </transition>


    <div id="page">
      <app-header></app-header>
      <div class="page-body">
        <app-navbar></app-navbar>

        <div class="main-page-content  ml-0">
          <template v-if="!submissions && role==='manager'">
            <div class="no-submissions spinner h-100 text-center d-flex justify-content-center align-items-center"
            >
              <div>
                <i class="fa-3x fas fa-circle-notch fa-spin"></i>
                <p class="mt-3 mb-2">{{$t('message.please_wait')}}</p>
                <p class="small">{{$t('message.user_vitamins_are_being_loaded')}}</p>

              </div>

            </div>
          </template>
          <template v-else-if="!submissions">
            <div class="no-submissions spinner h-100 text-center d-flex justify-content-center align-items-center"
            >
              <div>
                <i class="fa-3x fas fa-circle-notch fa-spin"></i>
                <p class="mt-3 mb-2">{{$t('message.please_wait')}}</p>
                <p class="small">{{$t('message.vitamins_are_being_loaded')}}</p>

              </div>

            </div>
          </template>
          <template v-else>
            <div id="main-wrapper" class="layout-main-wrapper clearfix" v-show="submissions">
              <div id="main" class="container-fluid">
                <div class="row row-offcanvas row-offcanvas-left clearfix">
                  <main class="main-content col content-full-width" id="content" role="main">
                    <section id="evolution" class="section">
                      <div class="mb-3  align-items-center" v-if="$route.params.uid">
                        <h2 class="mb-1">
                          {{$t('message.vitamin_overview_for',{username:user.fullname})}}
                        </h2>
                        <div class="">
                          <router-link href="" class=" h-auto p-0  btn btn-link" to="/userlist">
                            <small>
                              <span class="mr-2"><i class="far fa-chevron-left"></i></span>{{$t('message.back_to_userlist')}}
                            </small>
                          </router-link>
                        </div>
                      </div>
                      <div class="row">
                        <template v-if="role === 'manager'">
                          <div v-if="submissions.length === 0" class="col-md-12">
                            <p>{{$t('message.user_no_submissions_yet')}}</p>
                            <router-link class="btn btn-primary" tag="button" to="/userlist">
                              {{$t('message.back_to_users')}}
                            </router-link>
                          </div>
                        </template>
                        <template v-else>
                          <div v-if="submissions.length === 0" class="col-md-12">
                            <p>{{$t('message.no_submissions_yet')}}</p>
                            <router-link class="btn btn-primary" tag="button" to="/vitamins">
                              {{$t('message.start_first_vitamin')}}
                            </router-link>
                          </div>
                        </template>


                        <div v-if="submissions.length"
                             v-for="(submission,i) in submissions"
                             v-bind:key="submission.id"
                             :data-id="submission.id"
                             class="mb-14 col-sm-12 col-md-6 col-lg-4 col-xl-3 col-xxl-2 evolution-item"
                             :class="statusClass(submission)">
                          <!--                          <template>-->

                          <template v-if="submission.status === 'draft'">
                            <template v-if="role !== 'manager'">
                              <router-link tag="div"
                                           to="/vitamins?draft=true"
                                           class="nav-item"
                                           active-class="active">
                                <card :vitamins="vitamins" :submission="submission"></card>
                              </router-link>
                            </template>
                            <template v-else>
                              <card @click.prevent="openSubmissionPopup(submission)" :vitamins="vitamins"
                                    :submission="submission"></card>
                            </template>
                          </template>
                          <template v-else>
                            <div @click.prevent="openSubmissionPopup(submission)">
                              <card class="" :vitamins="vitamins" :submission="submission"></card>
                            </div>
                          </template>

                          <!--                            <template v-else-if="submission.status === 'final'">-->
                          <!--                              <router-link :index="i" :id="submission.id" tag="div"-->
                          <!--                                           :to="'/review/'+submission.id+($route.params.uid ? '/'+$route.params.uid : '')"-->
                          <!--                                           class="nav-item" active-class="">-->
                          <!--                                <card :vitamins="vitamins" :data-id="submission.id" :submission="submission"></card>-->
                          <!--                              </router-link>-->
                          <!--                            </template>-->
                          <!--                            <template v-else>-->
                          <!--                              <router-link :index="i" :id="submission.id" tag="div"-->
                          <!--                                           :to="'/review/'+submission.id+($route.params.uid ? '/'+$route.params.uid : '')"-->
                          <!--                                           class="nav-item" active-class="">-->
                          <!--                                <card :vitamins="vitamins" :data-id="submission.id" :submission="submission"></card>-->
                          <!--                              </router-link>-->
                          <!--                            </template>-->

                          <!--                          </template>-->
                        </div>


                      </div>
                    </section>
                  </main>
                </div>
              </div>
            </div>
          </template>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Header from "../Header";
  import Nav from "../Nav";
  import axios from '../../axios-auth';
  import Card from "./Card";
  import store from "../../store/store";
  import UserReview from "../Review/UserReview"
  import moment from 'moment';

  export default {
    components: {
      appHeader: Header,
      appNavbar: Nav,
      card: Card,
      UserReview
    },
    methods: {
      // formatDate(date) {
      //   return moment(date).format('DD/MM/YYYY')
      // },
      openSubmissionPopup(team) {
      //  console.log('opening popup');
        this.popupSubmission = team;
        this.popupShown = true;
      },
      closePopup() {
        // this.popupTeam = null;
        this.popupShown = false;
        // this.popupType = '';
      },
      getVitamins() {
        this.axios.get('/vitamines?_sort=sort:ASC&published=1').then(vitamins => vitamins.data)
          .then(res => {
            this.vitamins = res;
            // console.log('vitamins gotten', this.vitamins)
          });
      },
      getsubmissions() {
        let endpoint = '/submissions?_sort=submitted:DESC';
        if (this.role === 'manager') {
          endpoint = '/submissions/user/' + this.$route.params.uid + '?_sort=submitted:DESC&published=1'
        }
        this.axios.get(endpoint).then(res => {
          this.submissions = res.data;
          // console.log('subs', this.submissions)
          // this.renderthis = true;
        })
      },
      statusClass(submission) {
        return submission.status === 'draft' ? 'item-draft' : '';
      }
    },
    created() {
      this.role = store.state.viewMode;
      this.getsubmissions();
      this.getVitamins();
      if (this.$route.params.uid) {
        // console.log('viewing evolution for user', this.$route.params.uid)
        this.axios.get('/users/' + this.$route.params.uid).then(r => {
          this.user = r.data
          // console.log('user being viewed',this.user)
        })
      }
    },

    data() {
      return {

        user: store.getters.getUser,
        popupShown: false,
        popupSubmission: null,
        vitamins: [],
        role: null,
        submissions: null,
        // renderthis: false
      }
    }
  }
</script>


<style>
  @keyframes slide-in {
    from {
      top: -200%;
    }
    to {
      top: 0;
    }
  }

  @keyframes slide-out {
    from {
      top: 0;
    }
    to {
      top: -200%;
    }
  }

  .teampopupdash-enter {

  }

  .teampopupdash-enter-active {
    animation: slide-in .5s ease-out forwards;
  }

  .teampopupdash-leave {

  }

  .teampopupdash-leave-active {
    animation: slide-out .5s ease-out forwards;
  }
</style>



// WEBPACK FOOTER //
// src/components/Evolution/Evolution.vue